import React, { Component } from 'react';
import { connect } from 'react-redux';

import TransactionInvoice from './transactionInvoice';
import ReportingDocumentTree from '../documentViewers/json/AvaJsonTreeview';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSACTION_CONTAINER', LOG_LEVELS.DEBUG);


class TransactionContainer extends Component {

  render() {
    log.debug('render(): ', this.props);
    log.debug('transactionDetails(): ', this.props.transactionDetails);
      log.debug('transactionDetails(): ',this.props.deleteLogs );


    const txData = this.props.transactionDetails;
    const warnings = this.props.warnings || [];
    const deleteLogs =  this.props.deleteLogs || [];

    if (!txData) {
      return(
        <div><LanguageStringResolver string='transactionInvoice_noData'/></div>
      )
    }

    return(
      <div>
        <div className="summary-panel">
          <TransactionInvoice
            invoice={txData}
            warnings={warnings}
            deleteLog={deleteLogs}
          />
        </div>
      </div>
   );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


TransactionContainer.defaultProps = {
  transaction: {},
  warnings: [],
    deleteLogs : []
};

function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(TransactionContainer);
